import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import Api from "../../../../../Services/Api";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleInput from "../../../../../modules/SimpleInput";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import { mapToObjectDDL } from "../../../../common/mapper";

class ReceivingUnitDGIFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      variantOptions: [],
      warnaOptions: [],
    };
  }

  async componentDidMount() {
    let apiList = [this.handleCallApi("variant")];
    if (!R.isNil(this.getDataValue("kodeVarian", null))) {
      apiList.push(this.handleCallApi("warna", this.props.state.filterData.kodeVarian.value));
    }
    const responses = await Promise.all(apiList);
    if (responses[0] && !R.isEmpty(responses[0])) {
      this.setState((prevValue) => ({
        ...prevValue,
        variantOptions: responses[0].map((v) => mapToObjectDDL(v.kodeVariant, v.kodeVariant)),
      }));
    }
    if (responses[1] && !R.isEmpty(responses[1])) {
      this.setState((prevValue) => ({
        ...prevValue,
        warnaOptions: responses[1].map((w) => mapToObjectDDL(w.namaWarnaPabrik, w.kodeWarna)),
      }));
    }
  }

  handleCallApi = async (name, value) => {
    let api = Api.create("NAGAMAS_MASTER_DATA");
    let response;
    try {
      if (R.equals(name, "variant")) {
        response = await api.getAllVariant();
      } else {
        response = await api.getAllWarnaByParam({
          paramFilters: {
            kodeVariant: value,
          },
        });
      }

      if (response.ok) {
        return response.data.data;
      }
    } catch (error) {
      // TODO
    }

    return [];
  };

  handleValueChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleDateChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleClearFilter = () => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {},
    }));
  };

  handleVarianChange = async (name, value) => {
    this.handleValueChange("kodeWarna", null);
    this.handleValueChange(name, value);
    if (value) {
      const data = await this.handleCallApi("warna", value.value);
      this.setState((prevValue) => ({
        ...prevValue,
        warnaOptions: data.map((w) => mapToObjectDDL(w.namaWarnaPabrik, w.kodeWarna)),
      }));
    }
  };

  getDataValue(fieldName, fallbackValue = "") {
    return !R.isNil(this.props.state.filterData) && this.props.state.filterData[fieldName]
      ? this.props.state.filterData[fieldName]
      : fallbackValue;
  }

  render() {
    return (
      <SimpleModal
        title="Filter Search"
        visible={this.props.state.filterVisible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
              <FlexView column>
                <FlexView column vAlignContent="center">
                  <div className="txt-site txt-11 txt-main txt-bold">
                    <h4>Tanggal SL:</h4>
                  </div>
                  <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                    <SimpleDate
                      id="select_date_startDateSL"
                      name="startDateSL"
                      nextdate
                      date={this.getDataValue("startDateSL", null)}
                      maxDate={this.getDataValue("endDateSL", null)}
                      onChange={(value) => this.handleDateChange("startDateSL", value)}
                    />
                    <span className="margin-bottom-20px">To</span>
                    <SimpleDate
                      id="select_date_endDateSL"
                      name="endDateSL"
                      nextdate
                      date={this.getDataValue("endDateSL", null)}
                      onChange={(value) => this.handleDateChange("endDateSL", value)}
                    />
                  </FlexView>
                </FlexView>
                <SimpleInput
                  id="input_text_no_shipping_list"
                  name="slNo"
                  label="No. Shipping List (SL)"
                  value={this.getDataValue("slNo")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />
                <SimpleInput
                  id="input_text_invoiceNo"
                  name="invoiceNo"
                  label="No. Invoice"
                  value={this.getDataValue("invoiceNo")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />
                <h3>Filter Detail</h3>
                <SimpleDDL
                  id="select_options_kode_varian"
                  box="search"
                  name="kodeVarian"
                  label="Kode Varian"
                  isClearable
                  options={this.state.variantOptions}
                  value={this.getDataValue("kodeVarian")}
                  onChange={(value, { name }) => this.handleVarianChange(name, value)}
                />
                <SimpleInput
                  id="input_text_norangka"
                  name="rangkaNo"
                  label="No. Rangka"
                  value={this.getDataValue("rangkaNo")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />
                <SimpleInput
                  id="input_text_nomesin"
                  name="mesinNo"
                  label="No. Mesin"
                  value={this.getDataValue("mesinNo")}
                  onChange={({ target }) => this.handleValueChange(target.name, target.value)}
                />
                <SimpleDDL
                  id="select_options_warna"
                  box="search"
                  name="kodeWarna"
                  label="Warna"
                  isClearable
                  readOnly={R.isNil(this.getDataValue("kodeVarian", null))}
                  options={this.state.warnaOptions}
                  value={this.getDataValue("kodeWarna")}
                  onChange={(value, { name }) => this.handleValueChange(name, value)}
                />
              </FlexView>
              <FlexView hAlignContent="right" style={{ gap: "10px" }}>
                <SimpleButton type="button" secondary onClick={this.handleClearFilter}>
                  Clear
                </SimpleButton>
                <SimpleButton onClick={this.props.onSubmit}>Terapkan</SimpleButton>
              </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

export default ReceivingUnitDGIFilter;
